import { gql } from '@apollo/client'

export default gql`
  mutation deleteUsers($userIds: [ID]!, $organizationId: ID!) {
    deleteUsers(userIds: $userIds, organizationId: $organizationId)
  }
`
